import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Truck, Star } from 'lucide-react';

const formatNumber = (num) => {
  if (num === undefined || num === null) return '-';
  return new Intl.NumberFormat('ro-RO').format(num);
};

const formatCurrency = (num) => {
  if (num === undefined || num === null) return '-';
  return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' }).format(num);
};

export const SuppliersTab = ({ suppliers }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Furnizori si Preturi</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Furnizor</TableHead>
              <TableHead className="text-right">Ultimul Pret</TableHead>
              <TableHead className="text-right">Pret Mediu</TableHead>
              <TableHead className="text-right">Min / Max</TableHead>
              <TableHead className="text-right">Total Cumparat</TableHead>
              <TableHead className="text-right">Nr. Receptii</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {suppliers?.map((sup, idx) => (
              <TableRow key={sup.supplier_id || idx}>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <Truck className="w-4 h-4 text-slate-400" />
                    <span className="font-medium">{sup.supplier_name}</span>
                    {sup.is_preferred && (
                      <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-100 text-xs">
                        <Star className="w-3 h-3 mr-0.5" /> PREFERAT
                      </Badge>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-right font-semibold">{formatCurrency(sup.last_price)}</TableCell>
                <TableCell className="text-right">{formatCurrency(sup.avg_price)}</TableCell>
                <TableCell className="text-right text-sm text-slate-500">
                  {formatCurrency(sup.min_price)} / {formatCurrency(sup.max_price)}
                </TableCell>
                <TableCell className="text-right">{formatNumber(sup.total_quantity)} buc</TableCell>
                <TableCell className="text-right">{sup.total_receipts}</TableCell>
              </TableRow>
            ))}
            {suppliers?.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center py-8 text-slate-400">
                  Nu exista furnizori configurati
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
